module.exports = __webpack_public_path__ + "img/swiper_3.5_1_3.0c77adae.webp";